/**
 * Validates that a value is not empty.
 * @param {string} value
 * @returns {string} Error message if invalid; empty string otherwise.
 */
export function validateRequired(value: string, name: string): string {
  return value?.trim() === "" ? `${name} is required` : "";
}

/**
 * Validates an email address.
 * @param {string} value
 * @returns {string} Error message if invalid; empty string otherwise.
 */
export function validateEmail(value: string): string {
  if (value?.trim() === "") return "Email is required";
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
  return emailPattern?.test(value) ? "" : "Invalid email address";
}

export const regexForHousinghand =
  /^https?:\/\/(([^\/]+\.)*zh\.)housinghand\.[^\/]+/i;

export const getDeviceType = () => {
  const userAgent = navigator?.userAgent?.toLowerCase() || "";

  const isTablet =
    /ipad|tablet|kindle|silk|playbook|nexus\s?(7|9|10)|xoom|sch-i800|gt-p\d+|sm-t\d+|sm-p\d+|lenovo.*tab|yoga.*tab|transformer|tf\d+|mediapad|surface|mipad|tab\d+|a\d+-\d+|xperia.*tablet|webos.*tablet|rim.*tablet|bb.*tablet|huawei.*mediapad|asus.*pad|acer.*iconia|hp.*touchpad|nook|kobo|fire\s?hd|galaxy.*tab|ipad.*pro|ipad.*air|ipad.*mini|fold.*tablet|z.*fold.*tablet|android(?!.*mobile)|windows(?=.*touch)(?!.*phone)|macintosh.*(?:ipad|tablet)/i.test(
      userAgent
    ) ||
    (navigator?.platform === "MacIntel" && navigator?.maxTouchPoints > 1);

  const isMobile =
    !isTablet &&
    /phone|mobile|android.*mobile|iphone|ipod|blackberry|bb\d+|palm|webos.*mobile|windows\s?(phone|mobile|ce)|iemobile|wpdesktop|opera\s?mini|mobile.*(firefox|safari|chrome|edge)|fennec|maemo|blazer|compal|elaine|hiptop|avantgo|sony\s?psp|nintendo|vita|3ds|samsung.*mobile|nokia|htc|lg.*mobile|motorola.*mobile|huawei.*mobile|xiaomi.*mobile|oppo|vivo|oneplus|realme|honor.*mobile|redmi|poco|iqoo|meizu|zte.*mobile|tcl.*mobile|infinix|tecno|vodafone|orange|t-mobile|verizon.*mobile|wap|up\.browser|up\.link|mmp|symbian|smartphone|pda|pocket|portable|handheld|mobi|mini|mobile.*safari|mobile.*webkit|android.*wv|crios|fxios|edgios/i.test(
      userAgent
    );

  const isLaptop =
    !isTablet &&
    !isMobile &&
    /windows\s?(nt|10|11|12)|win32|win64|wow64|mac\s?os|macintosh|darwin|linux|ubuntu|debian|fedora|centos|suse|arch|mint|manjaro|elementary|zorin|freebsd|openbsd|netbsd|sunos|solaris|aix|chromeos|cros\s|x11|desktop|pc|workstation|electron|smart.*tv|smarttv|tv|googletv|appletv|roku|fire.*tv|xbox|playstation|ps\d+|nintendo.*switch|steam.*deck/i.test(
      userAgent
    );

  if (isTablet) return "tab";
  if (isMobile) return "mobile";
  if (isLaptop) return "laptop";
  return "laptop";
};
